import { createCrudSlice } from 'app/createCrudSlice';
import { roleService } from 'services/roleService';

const { reducer, thunks } = createCrudSlice({ name: 'roles', service: roleService });

export const {
  fetch: fetchRoles,
  create: createRole,
  update: updateRole,
  remove: deleteRole,
} = thunks;

export default reducer;
